<template>
    <van-popup
    :value="value"
    position="bottom"
    :style="{ height: '70%' }" 
    :closeable="true"
    @click-close-icon="handleClose"
    :close-on-click-overlay="false"
    >
        <div class="spec-head">
          <div class="current-goods">
            <img v-if="currentGoods.pic" :src="currentGoods.pic">
            <div>{{ currentGoods.price }}</div>
            <div class="current-spec">当前选中: {{ currentGoods.spec }}</div>
          </div>
        </div>
        <div v-for="(item, index) of spaceList" :key="index" class="cate">
          <div>{{ item.spec_title }}</div>
          <div class="cate-spec">
            <div 
              class="cate-spec-item" 
              @click="selectSpec(index, cIndex)"
              v-for="(cItem, cIndex) of item.spec_list"
              :key="cItem.id"
              :class="actived(index, cIndex) ? 'cate-active': '' "
              >
                <img v-if="cItem.spec_pic" :src="cItem.spec_pic">
                <div>{{ cItem.spec_name }}</div>
              </div>
          </div>
        </div>
    </van-popup>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'valueChange'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    datas: {
      type: Array,
      default: () => []
    },
    price: {
      type: String,
      default: () => '0'
    }
  },
  data() {
    return {
      selectedGoods: [],
      spaceList: [],
    }
  },
  methods: {
    // 选中处理
    actived (index, cIndex) {
     return (this.spaceList[index].spec_list[cIndex].spec_id === this.selectedGoods[index].spec_id)
    },
    // 选择规格
    selectSpec (index, cIndex) {
      this.selectedGoods.splice(index,1, this.spaceList[index].spec_list[cIndex])
    },
    handleClose () {
      console.log(1000);
      this.$emit('valueChange', false)
    }
  },
  computed: {
    currentGoods () {
      let goodsInfo = {
        spec: '',
        price: ''
      }
      this.selectedGoods.forEach((item, index) => {
        if (item.spec_pic) {
          goodsInfo.pic = item.spec_pic
        }
        const p = index < this.selectedGoods.length - 1 ? ',' : ''
        goodsInfo.spec += item.spec_name + p
      })
      return goodsInfo
    }
  },
  watch: {
    datas: {
      handler (val) {
        // 初始化选中商品规格
        this.spaceList = val.map((item, index) => {
          if (item.spec_list.length > 0) {
            // item.spec_list[0].active = true
            // 默认选中第一个
             this.selectedGoods.splice(index,1, item.spec_list[0])
            // this.selectedGoods[index] = item.spec_list[0]
          }
          return item
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$img-size: 2rem;
  .spec-head{
    margin: 0.8rem 0;
    .current-goods{
      margin: 0.2rem;
      text-align: center;
      .current-spec{
        background: $globalcolor;
        width: fit-content;
        padding: .1rem 0.3rem;
        color: #fff;
        margin: auto;
        border-radius: 5px;
        font-size: 14px;
      }
      img {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  }
  .cate-active {
    border: 1px solid $globalcolor;
    border-radius: 5px;
  }
  .cate {
    margin: 0.1rem;
  }
  .cate-spec{
    display: flex;
    flex-wrap: wrap;
    margin: 0.2rem 0;
    .cate-spec-item{
      width: $img-size;
      text-align: center;
      padding: 0.1rem;
      img {
        width: $img-size;
        height: $img-size;
        border-radius: 5px;
      }
    }
  }
  
</style>